export default __webpack_public_path__ + "static/media/DollarsIcon.6b533fe1.png";